import React, { useEffect } from 'react';
import { Child } from 'pym.js';

import Paper from '@material-ui/core/Paper';
import debounce from 'lodash.debounce';
import { makeStyles } from '@material-ui/styles';

import Header from './Header';
import Form from './Form';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(3, 0),
    margin: theme.spacing(3, 0),
    borderTop: '1px solid rgb(140, 140, 140)',
    borderBottom: '1px solid rgb(140, 140, 140)',
    '@media (min-width: 600px)': {
      boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.25)',
      border: 'none',
      padding: theme.spacing(3),
    },
  },
  button: {
    ...theme.button,
    marginBottom: theme.spacing(1),
    fontWeight: 500,
  },
  disclaimer: {
    // disclaimer styles...
  },
  headline: {
    // headline styles...
  },
  lead: {
    marginTop: theme.spacing(2),
  },
  textField: {
    '& legend': {
      display: 'none',
    },
    '& textarea': {
      paddingTop: 10,
    },
  },
  outlinedInput: {
    // overrides
    transform: 'translate(14px, 8px) scale(1) !important',
  },
  shrunkInput: {
    // overrides
    transform: 'translate(14px, 8px) scale(0.75) !important',
  },
  animatedInput: {
    // overrides
    color: 'rgb(140, 140, 140)',
  },
  form: {
    marginTop: theme.spacing(3),
  },
  formControl: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  snackbarContent: {
    maxWidth: 350,
  },
}));

function Project(props) {

  const classes = useStyles();

  const handleResize = debounce(() => {
    // window resized
    window.pymChild.sendHeight();
  }, 300);

  useEffect(() => {
    // init pym on load
    window.pymChild = new Child();
    window.pymChild.sendHeight();

    // sub
    window.addEventListener('resize', handleResize);

    // unsub
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Paper square={true} elevation={0} className={classes.paper}>
      <Header
        classes={{
          headline: classes.headline,
          lead: classes.lead,
        }}
      />
      <Form
        classes={{
          form: classes.form,
          formControl: classes.formControl,
          button: classes.button,
          root: classes.root,
          disclaimer: classes.disclaimer,
          textField: classes.textField,
          animatedInput: classes.animatedInput,
          shrunkInput: classes.shrunkInput,
          rootInput: classes.rootInput,
          outlinedInput: classes.outlinedInput,
          snackbarContent: classes.snackbarContent,
        }}
      />
    </Paper>
  );
}

export default Project;
